const state = {
  websocketState: sessionStorage.getItem("websocketState") ? JSON.parse(sessionStorage.getItem("websocketState")) : '',
}
const getters = {
  websocketState: state => state.websocketState
}

const mutations = {
  'UPDATEWEBSOCKETSTATE' (state, status) {
    state.websocketState = status
    console.log(state.websocketState, 'state.websocketState')
    sessionStorage.setItem("websocketState", status)
  }
}
console.log(getters, 'getters')
export default{
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/websocket/index.js